module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/main/memberstorage'
      },
      "replace": ""
    }
  }, [_vm._v("会员储值")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("创建储值")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "review-info__wrapper"
  }, [(!_vm.role.single) ? _c('div', {
    staticClass: "review-info flex"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc__wrapper"
  }, [_c('div', {
    staticClass: "info-desc"
  }, [_c('div', _vm._l((_vm.shopList), function(shop, index) {
    return _c('span', [_vm._v(_vm._s(shop.shop_name) + _vm._s(index < _vm.shopList.length - 1 ? "、" : ""))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "info-desc remark mt-0 lh-16 ml-0"
  }, [_vm._v("注：请确保以上门店均已开通储值服务，否则无法正常储值")])])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("开始时间")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.start_time))])])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("结束时间")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.end_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "review-info flex"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("储值规则")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc__wrapper"
  }, [_c('div', {
    staticClass: "info-desc"
  }, _vm._l((_vm.data.rules), function(rule) {
    return _c('div', [_vm._v("储值"), _c('span', {
      staticClass: "highlight"
    }, [_vm._v(_vm._s(_vm._f("addZero")(rule.pay_amt)))]), _vm._v("元送"), _c('span', {
      staticClass: "highlight"
    }, [_vm._v(_vm._s(_vm._f("addZero")(rule.present_amt)))]), _vm._v("元\n              ")])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "review-info flex"
  }, [_c('span', {
    staticClass: "info-title no-shrink"
  }, [_vm._v("储值规则备注")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.desc))])])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("预留电话")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.mobile))])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-submit_wrapper"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.backToEdit
    }
  }, [_vm._v("返回修改")]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_c('i', {
    staticClass: "icon-create"
  }), _vm._v("确认提交")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("预览储值信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0545b55d"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/reviewstorage/reviewstorage.vue
// module id = 805
// module chunks = 0